import * as yup from 'yup'

const schema = yup.object({
  pageTitle: yup.string().optional().max(180),
  pageSubtitle: yup.string().optional().max(200),
  primaryColor: yup.string().required().min(4).max(7),
  primaryFontColor: yup.string().required(),
  secondaryColor: yup.string().required().min(4).max(7),
  secondaryFontColor: yup.string().required(),
})

export default schema
